module.exports = __webpack_public_path__ + "img/registration-closed.9322f4bb.png";